//#region IMPORTS
import InstoreOrdersContainer from "../../components/instoreOrders/InstoreOrdersContainer";
import { useAppDispatch, useAppSelector } from "../../store/configureStore";
import { fetchInstoreOrdersAsync } from "./instoreOrdersSlice";
import { fetchFilters } from "../orders/ordersSlice";
import { useEffect } from "react";
//#endregion

//#region INTERFACE
interface Props {
  title: string;
}
//#endregion

export default function InstoreOrdersPage({ title }: Props) {
  //#region SETUP
  // Redux
  const dispatch = useAppDispatch();
  const { instoreOrdersLoaded } = useAppSelector(
    ({ instoreOrders }) => instoreOrders
  );
  const { filters_loaded } = useAppSelector(({ orders }) => orders);
  //#endregion

  //#region LOGIC
  // Load orders
  useEffect(() => {
    const fetchOnload = async () => {
      if (!instoreOrdersLoaded) {
        await dispatch(fetchInstoreOrdersAsync());
      }
    };
    fetchOnload();
  }, [instoreOrdersLoaded, dispatch]);

  // Load filters
  useEffect(() => {
    const fetchFiltering = async () => {
      await dispatch(fetchFilters());
    };
    !filters_loaded && fetchFiltering();
  }, [filters_loaded, dispatch]);
  //#endregion

  return <InstoreOrdersContainer title={title} />;
}
